import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-ink/5 bg-ink text-cream">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-4 max-w-md text-sm leading-relaxed text-cream/70">
            Aurelia is a colorful house of hotels and wedding halls — built for
            vows, after-parties, and the nights people still talk about.
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold">
            Explore
          </p>
          <div className="mt-4 flex flex-col gap-2 text-sm text-cream/75">
            <Link to="/venues">All venues</Link>
            <Link to="/venues?type=hotel">Hotels</Link>
            <Link to="/venues?type=wedding-hall">Wedding halls</Link>
            <Link to="/login">Owner sign in</Link>
          </div>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold">
            Atelier
          </p>
          <p className="mt-4 text-sm text-cream/75">Colombo · Kandy · Galle</p>
          <p className="mt-2 text-sm text-cream/75">hello@aurelia.events</p>
        </div>
      </div>
      <div className="border-t border-white/10 px-4 py-5 text-center text-xs text-cream/45">
        © {new Date().getFullYear()} Aurelia Celebrations. Made for glittering nights.
      </div>
    </footer>
  );
}
